<template>
  <Button
    type="solid"
    variant="blue"
    icon="general.tick"
    data-testid="viewer-transcription-save"
    :loading="isSaving"
    :disabled="isSaving"
    @click.prevent="saveAll"
    >Apply</Button
  >
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Button } from '@/storybook';
import { TrackEvents, useViewerTrack } from '@/modules/viewer/composables/useViewerTrack';
import { useTranscriptContent } from '@/modules/viewer/composables/useTranscriptContent';

const { trackItemOwner } = useViewerTrack();
const { saveEdits } = useTranscriptContent();

const emit = defineEmits(['update:editing']);
const isSaving = ref(false);

const saveAll = () => {
  isSaving.value = true;

  trackItemOwner(TrackEvents.VIEWER_TRANSCRIPTION_CORRECTION_APPLY);
  return saveEdits().finally(() => {
    emit('update:editing', false);
    isSaving.value = false;
  });
};
</script>
